<template>
  <crud-form
    v-model="payload"
    page-title="Adicionar categoria"
    :request-class="requestClass"
    :total-group="3"
    navigate-back-route="contacard.faq.categories.list"
    navigate-page-after-save="contacard.faq.categories.list"
    :override-create-payload="overrideCreatePayload"
    :override-edit-payload="overrideEditPayload"
    :override-set-entity-data="overrideSetEntityData"
  >
    <template slot="group-1">
      <form-group title="Dados da categoria">
        <v-row>
          <v-col cols="6">
            <input-text
              v-model="payload.name"
              :rules="[requiredRule, maxLength(60), onlyAsciiCharacters()]"
              label="Nome"
              outlined
              required
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-textarea
              id="input:Descrição"
              v-model="payload.description"
              :rules="[requiredRule, maxLength(120), onlyAsciiCharacters()]"
              label="Descrição"
              outlined
            />
          </v-col>
        </v-row>
      </form-group>
    </template>
  </crud-form>
</template>

<script>
import CrudForm from 'Arch/components/crud/CrudForm.vue';
import CategoriesRequest from 'Modules/contacard/faq/categories/CategoriesRequest';
import FormGroup from 'Arch/components/crud/components/FormGroup.vue';
import RulesMixin from 'Arch/mixins/RulesMixin';

export default {
  name: 'InformativesForm',
  components: {
    CrudForm,
    FormGroup,
  },
  mixins: [RulesMixin],
  data: () => ({
    requestClass: CategoriesRequest,
    payload: {
      id: null,
      name: '',
      description: '',
    },
  }),

  methods: {
    overrideSetEntityData(data) {
      return {
        id: data.id,
        name: data.name,
        description: data.description,
      };
    },
    overrideCreatePayload() {
      return {
        id: this.payload.id,
        name: this.payload.name,
        description: this.payload.description,
      };
    },
    overrideEditPayload() {
      return {
        id: this.payload.id,
        name: this.payload.name,
        description: this.payload.description,
      };
    },
  },
};
</script>
